import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Input, Modal, Button } from "antd";
import accountActions from "../../redux/auth/actions";
import "./index.css";

const { register } = accountActions;

function SignUp() {
  const dispatch = useDispatch();

  const onFinish = (user) => {
    dispatch(register(user));
  };

  return (
    <div className="sign-up-container">
      <Modal
        className="sign-up-modal"
        title={<div className="sign-in-title">Регистрация</div>}
        open={true}
        footer={null}
        closable={false}
      >
        <Form
          autoComplete="off"
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            name="firstName"
            rules={[
              {
                required: true,
                message: "Името е задължително!",
              },
              {
                min: 2,
                message: "Името не може да бъде по-кратко от 2 символа!",
              },
              {
                max: 40,
                message: "Името не може да бъде по-дълго от 40 символа!",
              },
            ]}
          >
            <Input placeholder="Име" size="large" />
          </Form.Item>
          <Form.Item
            name="lastName"
            rules={[
              {
                required: true,
                message: "Фамилията е задължителна!",
              },
              {
                min: 2,
                message: "Фамилията не може да бъде по-кратка от 2 символа!",
              },
              {
                max: 40,
                message: "Фамилията не може да бъде по-дълга от 40 символа!",
              },
            ]}
          >
            <Input placeholder="Фамилия" size="large" />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Email е задължителен!",
              },
              {
                min: 2,
                message: "Email не може да бъде по-кратък от 2 символа!",
              },
              {
                type: "email",
                message: "Невалиден Email!",
              },
            ]}
          >
            <Input placeholder="Email" size="large" />
          </Form.Item>
          <Form.Item
            name="organizationName"
            rules={[
              {
                required: true,
                message: "Име на обект е задължителен!",
              },
              {
                min: 2,
                message: "Име на обект не може да бъде по-кратък от 2 символа!",
              },
            ]}
          >
            <Input placeholder="Име на обект" size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Моля въведете парола!",
              },
              {
                min: 6,
                message: "Паролата трябва да бъде минимум 6 символа!",
              },
            ]}
            hasFeedback
          >
            <Input.Password placeholder="Парола" size="large" />
          </Form.Item>
          <Form.Item
            name="repeatPassword"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Моля, потвърдете паролата!",
              },
              {
                min: 6,
                message: "Паролата трябва да бъде минимум 6 символа!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error("Паролите не съвпадат!"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Повторете" size="large" />
          </Form.Item>
          <Form.Item>
            <div className="sign-up-button">
              <Button type="primary" htmlType="submit">
                Регистирай се
              </Button>
            </div>
          </Form.Item>
        </Form>

        <div className="sign-up-button">
          <Link to="/signin">Вече имате акаунт? Кликнете тук за Вход</Link>
        </div>
      </Modal>
    </div>
  );
}

export default SignUp;
